import React from 'react';
import { Box } from '@mui/material';
import type { OptionSchema } from 'c-components';
import { AllEntitiesDropdown } from 'c-components';
import { useCommonTranslation } from 'c-translation';

type Props = {
    onChange: (skinId: number) => void;
    selectedSkinId: number;
    additionalOptions: OptionSchema[];
    disabled?: boolean;
};

const AdminSkinSwitcher: React.FC<Props> = ({
    onChange,
    selectedSkinId,
    additionalOptions,
    disabled = false,
}) => (
    // Stop keydown reaching the parent avatar Menu, whose type-ahead otherwise steals
    // letters that match a menu item's first character (e.g. "d"/"s") while typing here.
    <Box py={2} onKeyDown={e => e.stopPropagation()}>
        <AllEntitiesDropdown
            entityName="Skin"
            labelField="name"
            disabled={disabled}
            label={useCommonTranslation('Modules.Admin.SkinSwitcher.dropdownLabel')}
            value={selectedSkinId}
            onChange={onChange as any}
            additionalOptions={additionalOptions}
        />
    </Box>
);

export default AdminSkinSwitcher;
